"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  "ui:title": "Lenker",
  "ui:layout": "fieldset",
  "ui:options": {
    "draggable": true
  },
  "ui:buttons": [{
    "type": "add",
    "label": "Legg til"
  }],
  "items": {
    "ui:layout": "module",
    "ui:options": {
      "editable": true,
      "hideable": true
    },
    "ui:fieldset": ["content"],
    "content": {
      "ui:options": {
        "grid": true,
        "padding": 2,
        "spacing": 2
      },
      "ui:fieldset": ["title", "url"],
      "title": {
        "ui:title": "Tittel"
      },
      "url": {
        "ui:title": "URL"
      }
    }
  }
};
exports.default = _default;
module.exports = exports.default;